import { Container, Stack, Typography, Box, Divider } from '@mui/material';
import React from 'react';

const Manual = () => {
  const links = [
    {
      id: 1,
      label: 'Video tutorial pendataan aplikasi lama/existing',
      url: 'https://cloud.jogjaprov.go.id/index.php/s/DG78ghWkBQeiX9I'
    },
    {
      id: 2,
      label: 'Video tutorial pengajuan aplikasi baru',
      url: 'https://cloud.jogjaprov.go.id/index.php/s/2q4aOpp6ZuRiiNV'
    },
    {
      id: 3,
      label: 'Video tutorial pengajuan TTE (Tanda Tangan Elektronik)',
      url: 'https://cloud.jogjaprov.go.id/index.php/s/d8o1KJfyay5ZyMG'
    },
    {
      id: 4,
      label: 'Wiki Manual Peladen',
      url: 'https://wiki.jogjaprov.go.id/diskominfo/manual-peladen'
    }
  ];

  function LinkItem({ item }) {
    return (
      <Stack direction="row" spacing={2}>
        <Typography style={{ width: 16 }}>{item.id}.</Typography>
        <Stack direction="column">
          <Typography>{item.label}</Typography>
          <Typography>
            <a href={item.url} target="_blank" rel="noreferrer">
              {item.url}
            </a>
          </Typography>
        </Stack>
      </Stack>
    );
  }

  return (
    <Container>
      <Box mb={4}>
        <Typography variant="h4">Manual Peladen</Typography>
      </Box>

      <Stack direction="column" spacing={2}>
        <Typography>Berikut beberapa link panduan penggunaan Peladen:</Typography>
        <Divider />
        {links.map((item) => (
          <LinkItem key={item.id} item={item} />
        ))}
      </Stack>
    </Container>
  );
};

export default Manual;
